import { ValidateMessages } from '../../constants/ValidateConstants';
import ValidateField from '../../hooks/useValid';
import { ValidateName } from '../../constants/ValidateNameConstants';

export default function validation(values, modes) {
  let errors = {};

  errors.abbreviation = ValidateField(values.abbreviation, ValidateName?.ABBREVIATION,
    ValidateName?.ABBREVIATION, [ValidateName?.REQUIRED, ValidateName?.SHOULD_MAX_LETTER]);

  errors.deliveryDescription = ValidateField(values.deliveryDescription, ValidateName?.DELIVERY_TERMS,
    ValidateName?.DELIVERY_TERMS, [ValidateName?.REQUIRED]);

  errors.termsTooltip = ValidateField(values.termsTooltip, ValidateName?.DELIVERY_DESCRIPTION,
    ValidateName?.DELIVERY_DESCRIPTION, [ValidateName?.REQUIRED]);

  if (modes?.length == 0) {
    errors.transportMode = ValidateMessages.TRANSPORT_MODE;
  }
  return errors;
}


